import PositionDto from '@/models/Positions/PositionDto';
import SkillDto from '@/models/Skills/SkillDto';
import AvailabilityViewModel from '@/models/Workers/AvailabilityViewModel';
import Availability from '@/models/Workers/Availability';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import NumbersViewModel from '@/models/Shared/NumberViewModel';
import ListUtils from '@/lib/listUtils';
import WorkerStatusViewModel from '@/models/Workers/WorkerStatusViewModel';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkType from '@/models/Shared/WorkType';
import SearchMatchType from '@/models/Shared/SearchMatchType';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';

export default class WorkerSearchViewModel {
    searchMatchTypes: NumbersViewModel[] = ListUtils.searchMatchTypes();
    statuses: WorkerStatusViewModel[] = ListUtils.workerStatuses();
    selectedStatus: WorkerStatus = WorkerStatus.Active;
    workTypes: WorkType[] = ListUtils.workTypes();
    selectedWorkTypes: WorkType[] = ListUtils.workTypes();
    positions: PositionDto[] = []
    selectedPositions: PositionDto[] = [];
    selectedSkills: SkillDto[] = [];
    selectedSkillMatchType: SearchMatchType = SearchMatchType.All;
    selectedQualifications: QualificationDto[] = [];
    selectedQualificationMatchType: SearchMatchType = SearchMatchType.All;
    includeAvailability = false;
    availabilityOptions: AvailabilityViewModel[] = [];
    selectedAvailabilityCodes: AvailabilityViewModel[] = [];
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    branches: BranchDto[] = [];
    selectedBranch: BranchDto;
    selectedDesk: DeskDto;
    distanceOptions: DistanceViewModel[] = [];
    selectedDistance: DistanceViewModel = new DistanceViewModel(20, "20");
    passengerOptions: NumbersViewModel[] = []
    driversOnly = false;
    matchSalary = false;
    selectedMinimumPassengers = 0;
    isAgreedToMarketing = true;
    isFavouritesOnly = true;
    isIncludeBlocked = false;
    selectedShiftIds: string[] = []; // IDs of shifts to check for conflicts

    public constructor(branches: BranchDto[], positions: PositionDto[], selectedDistance: DistanceViewModel, includeAvailability: boolean) {
        this.branches = branches;
        this.positions = positions;
        this.availabilityOptions = ListUtils.availabilityTypes();
        this.includeAvailability = includeAvailability;

        this.distanceOptions.push(new DistanceViewModel(1, "1"));
        this.distanceOptions.push(new DistanceViewModel(2, "2"));
        this.distanceOptions.push(new DistanceViewModel(3, "3"));
        this.distanceOptions.push(new DistanceViewModel(4, "4"));
        this.distanceOptions.push(new DistanceViewModel(5, "5"));
        this.distanceOptions.push(new DistanceViewModel(6, "6"));
        this.distanceOptions.push(new DistanceViewModel(7, "7"));
        this.distanceOptions.push(new DistanceViewModel(8, "8"));
        this.distanceOptions.push(new DistanceViewModel(9, "9"));
        this.distanceOptions.push(new DistanceViewModel(10, "10"));
        this.distanceOptions.push(new DistanceViewModel(15, "15"));
        this.distanceOptions.push(new DistanceViewModel(20, "20"));
        this.distanceOptions.push(new DistanceViewModel(25, "25"));
        this.distanceOptions.push(new DistanceViewModel(30, "30"));
        this.distanceOptions.push(new DistanceViewModel(35, "35"));
        this.distanceOptions.push(new DistanceViewModel(40, "40"));
        this.distanceOptions.push(new DistanceViewModel(45, "45"));
        this.distanceOptions.push(new DistanceViewModel(50, "50"));
        this.distanceOptions.push(new DistanceViewModel(0, "Unlimited"));
        this.selectedDistance = selectedDistance;

        //this.vehicleAccessTypes = ListUtils.vehicleAccessTypes(false);
        this.passengerOptions = ListUtils.passengerOptions();
    }
}